import route from './route'
import { EntityIndex, EntityAdd } from '../components/views/entities'
const Home = () => import('@/views');

export default [
  route('/', Home, 'workstation', null, { title: 'Workstation' }, null, '/' + localStorage.getItem('GEODIS')),
  route('/:scope', EntityIndex, 'entities.home'),
  route('/:scope/:entity', EntityIndex, 'entities.index'),
  route('/:scope/:entity/add', EntityAdd, 'entities.add'),
  route('/:scope/:entity/:item/edit', EntityAdd, 'entities.edit'),
  route('/:scope/:entity/:item/view', EntityAdd, 'entities.view')
]
